import ItemListView from "../../../components/ItemListView/ItemListView.vue";

const defaultTableSettings = {
    columnState: [{
        headerName: "Type",
        field: "type",
        type: "notificationType",
        width: 120,
    }, {
        headerName: "Title",
        field: "title",
        minWidth: 220,
        flex: 1,
    }, {
        headerName: "Message",
        field: "body",
        minWidth: 300,
        flex: 2,
    }, {
        headerName: "Event",
        field: "eventType",
        width: 130,
    }, {
        headerName: "Created",
        field: "createdAt",
        type: "date",
        sort: "desc",
        width: 190,
    }, {
        headerName: "Read",
        field: "read",
        type: "bool",
        width: 110,
    }],
};

export default [{
    path: "/Home/Notifications",
    component: { ...ItemListView },
    name: "Notifications",
    meta: {
        app: "Home",
        sideNav: false,
        appSwitcher: false,
        name: "Notifications",
        tableSettings: "Notifications",
        defaultTableSettings,
        persistTableSettings: false,
        dataPath: "notifications",
        defaultEmptyData: true,
        applyDesignChangeFilter: false,
        dataQuery() {},
        map(notification) {
            return {
                ...notification,
                createdAt: notification.createdAt ? new Date(notification.createdAt) : null,
            };
        },
        itemSelected({ item, router }) {
            const destination = item.route || (item.sourcePath ? `/${item.sourcePath}` : null);
            if (destination) router.push(destination);
        },
        menuActions: [],
    },
}];
